import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getSpecificFeature } from "../../../redux/features/Settings/Management/Features";
import SVGComponent from "../../../components/_utils/SVGComponent";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";

import Loader from "../../../components/Loader/Index";
import CommonToast from "../../../components/_utils/CommonToast";

import ICONS from "../../../assets/Icons/index.js";
import { GlobalConfiguration } from "../../../utils/configurationProvider.js";

const FeaturesDetail = () => {
  const { user_feature_id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showFeatureDetails, setShowFeatureDetails] = useState(true);
  const [showServiceDetails, setShowServiceDetails] = useState(true);
  const [isAtTop, setIsAtTop] = useState(true);
  const scrollRef = useRef(null);

  const {
    getSpecificFeatureData,
    getSpecificFeatureIsLoading,
    getSpecificFeatureError,
  } = useSelector((state) => state.featuresSlice);

  useEffect(() => {
    dispatch(getSpecificFeature({ id: user_feature_id }));
  }, [dispatch, user_feature_id]);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;

      const scrollTop = scrollRef.current.scrollTop;
      setIsAtTop(scrollTop === 0);
    };

    const container = scrollRef.current;
    container?.addEventListener("scroll", handleScroll);

    return () => {
      container?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {}, [dispatch]);

  const featureDetails = getSpecificFeatureData?.features?.[0];
  const servicesDetails =
    getSpecificFeatureData?.features?.[0]?.user_features_line_items || [];

  const togglefeatureDetails = () => {
    setShowFeatureDetails(true);
    setShowServiceDetails(false);
  };

  const toggleServiceDetails = () => {
    setShowFeatureDetails(false);
    setShowServiceDetails(true);
  };

  return (
    <div className="ptc-main-bg-div fixed top-top-base left-left-base w-full-width h-full-height  bg-primary-bg z-z-index-base">
      <div
        className={`ptc-navbar-padding-div w-full fixed Qsmd:relative top-top-base z-z-index-header
    Qmd:h-[calc(var(--navbar-breadcrumb-height)-2px)] 
    h-auto block
    ${isAtTop ? "bg-transparent Qsmd:bg-primary-nav" : "bg-transparent"}
  `}
      >
        {" "}
        <div className="Qsmd:hidden fixed w-width-full p-padding-sm top-top-base bg-primary-nav flex items-center z-z-index-fixed-ui rounded-b-border-radius-md shadow-box-shadow-bottom">
          <div
            className="cursor-pointer pl-padding-sm pr-padding-md"
            onClick={() => navigate(-1)}
          >
            <SVGComponent
              url="https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
              color="var(--text-primary)"
              width="var(--icon-sm)"
              height="var(--icon-sm)"
            />
          </div>
          <div className="flex flex-col gap-gap-xs text-text-primary text-font-md">
            <div>Features</div>
            <div className="text-text-secondary text-font-xs">Detail page</div>
          </div>
        </div>
      </div>
      {getSpecificFeatureIsLoading && !getSpecificFeatureData ? (
        <div className="flex items-center justify-center h-full w-full">
          <SVGComponent
            url="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
            width="var(--icon-lg)"
            height="var(--icon-lg)"
          />
        </div>
      ) : (
        <div
          ref={scrollRef}
          className="flex flex-col h-full overflow-y-auto"
        >
          <div className="h-auto bg-primary-card Qsmd:bg-primary-nav block pt-padding-xl mt-margin-md Qsmd:pt-padding-base Qsmd:mt-margin-base">
            <div
              className={`w-full max-w-tab-width-normal m-auto bg-primary-nav"bene_account_detail_modal" ? "primaryDetailsandFunctionblock"`}
            >
              <div className=" flex flex-row Qsmd:border-b-border Qsmd:border-primary-bg  justify-between mt-margin-xs">
                <div
                  className="
  w-width-full
  flex
  flex-col
  Qsmd:flex-row

  Qsmd:py-padding-md

  px-padding-base
  Qsmd:px-padding-md
  Qlg:px-padding-base
"
                >
                  <div className="w-full Qsmd:flex">
                    <div className="accountName Qsmd:mx-margin-base Qmd:pl-padding-sm Qsmd:pl-padding-sm Qsmd:py-padding-base py-padding-button-l  Qsmd:px-padding-base mx-margin-md border-b-border border-primary-bg Qsmd:border-none w-auto flex flex-col Qsmd:w-width-md gap-y-gap-xs whitespace-normal break-words justify-center">
                      <TitleSubtitlePair
                        title={featureDetails?.feature_name}
                        subtitle="Feature name"
                      />
                    </div>
                    {/* <div className="h-[var(--border)] bg-primary-bg Qsmd:hidden block mx-margin-button-l"></div> */}
                    <div className="border-r border-solid border-primary-bg Qsmd:mx-margin-base mx-margin-button-l"></div>
                    <div className="accountStatus Qsmd:py-padding-base py-padding-button-l flex flex-col w-auto Qsmd:w-width-md gap-y-gap-xs mx-margin-md Qsmd:m-margin-base Qsmd:px-padding-md border-b-border border-primary-bg Qsmd:border-none justify-center">
                      <TitleSubtitlePair
                        title={featureDetails?.feature_header}
                        subtitle="Feature header"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="h-[var(--border)] bg-primary-bg block Qsmd:hidden Qsmd:mx-margin-base mx-margin-button-l"></div> */}
              <div className="primaryDetailsBlock2 flex flex-row border-b border-solid border-primary-bg justify-between">
                <div
                  className="
  w-width-full
  flex
  flex-col
  Qsmd:flex-row

  Qsmd:py-padding-md

  px-padding-base
  Qsmd:px-padding-md
  Qlg:px-padding-base
"
                >
                  <div className="w-full Qsmd:flex">
                    {" "}
                    <div className="Qsmd:border-none Qsmd:mx-margin-base Qsmd:pl-padding-sm Qsmd:w-width-md Qsmd:py-padding-base py-padding-button-l Qmd:pl-padding-sm flex flex-col Qsmd:px-padding-base mx-margin-md w-auto gap-y-gap-xs justify-center border-b-border border-primary-bg">
                      <TitleSubtitlePair
                        titleColor={
                          featureDetails?.is_delete == "N"
                            ? "settled"
                            : "failed"
                        }
                        title={
                          featureDetails?.is_delete == "N"
                            ? "Active"
                            : "Inactive"
                        }
                        subtitle="Status"
                      />
                    </div>
                    {/* <div className="h-[var(--border)] bg-primary-bg Qsmd:hidden block mx-margin-button-l"></div> */}
                    <div className="border-r border-solid border-primary-bg"></div>
                    <div className="accountHolderName Qsmd:py-padding-base py-padding-button-l flex flex-col w-width-md gap-y-gap-xs px-padding-md whitespace-normal break-words justify-center">
                      <TitleSubtitlePair
                        subtitle="Feature privilege"
                        title={featureDetails?.privilege || "N/A"}
                        titleColor="text-primary"
                        variant="md"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full">
            <div className="m-auto max-w-tab-width-normal relative z-z-index-base">
              <div className="flex pt-padding-md px-padding-md Qlg:px-padding-base">
                <div className="flex gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden">
                  <SwitcherTabs
                    tabs={[
                      {
                        label: "Details",
                        key: "details",
                        handler: togglefeatureDetails,
                      },
                      {
                        label: "Services",
                        key: "services",
                        handler: toggleServiceDetails,
                      },
                    ]}
                    initialActiveTab={
                      showFeatureDetails ? "details" : "services"
                    }
                  />
                </div>
              </div>
            </div>
            {showFeatureDetails ? (
              <div className="flex flex-col Qsmd:flex-row my-margin-md px-padding-md lg:px-padding-base gap-gap-md Qlg:justify-center">
                <CommonDetailCard
                  cardTitle="Feature Description"
                  numCols={1}
                  variant="third"
                  entries={[
                    {
                      heading: "Description",
                      content: featureDetails?.feature_description || "—",
                      type: "text",
                    },
                  ]}
                />

                <CommonDetailCard
                  cardTitle="Origin Details"
                  numCols={1}
                  variant="third"
                  entries={[
                    {
                      heading: "Created On",
                      content: formatDateViewAll(
                        featureDetails?.created_on,
                        true,
                        true,
                      ),
                      type: "text",
                    },
                  ]}
                />

                <CommonDetailCard
                  cardTitle="Support Information"
                  numCols={1}
                  variant="third"
                  entries={[
                    {
                      heading: "Feature ID",
                      content: featureDetails?.feature_id || "—",
                      type: "text",
                    },
                  ]}
                />
              </div>
            ) : showServiceDetails ? (
              <div className="z-z-index-base standard-card-alignment gap-x-gap-sm gap-y-gap-md relative  my-margin-md px-padding-md lg:px-padding-base mx-auto max-w-tab-width-normal Qsmd:pb-medium-screen-top-padding">
                {servicesDetails.length >
                GlobalConfiguration?.lengthCheckZero ? (
                  servicesDetails.map((service, index) => (
                    <CardContainer
                      key={service.service_id || index}
                      context={service}
                      isNoHoverRequired={false}
                      isDisabled={false}
                      isSelected={false}
                      onClickHandler={() => {
                        CommonToast({
                          text: "Feature coming soon",
                          icon: ICONS?.ERROR_WHITE_CIRCLE,
                          variant: "var(--coming-soon)",
                          btnProps: {
                            isDisabled: false,
                            enabledTextColor: "var(--text-primary)",
                            enabledBgColor: "var(--primary-bg)",
                          },
                        });
                      }}
                    >
                      <card-body>
                        <TextWithIcon
                          type={"text"}
                          fontWeight={"normal"}
                          text={service?.service_name}
                          subText={"Service name"}
                          textColor={"var(--text-primary)"}
                        />
                        <TextWithIcon
                          type={"text"}
                          fontWeight={"normal"}
                          text={service?.service_desc}
                          subText={"Service description"}
                          textColor={"var(--text-primary)"}
                        />
                      </card-body>
                    </CardContainer>
                  ))
                ) : (
                  <div className="text-text-secondary text-font-md">
                    No services assigned
                  </div>
                )}
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default FeaturesDetail;
